import React, { useState, useEffect } from "react";
import logo from "../images/logo.png";
import logoBlue from "../images/logo-blue.png";

function Navigation() {
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  const [imageUrl, setImageUrl] = useState(logo);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [isToggled, setIsToggled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPosition = window.pageYOffset;
      setIsScrollingDown(currentScrollPosition > previousScrollPosition);
      setIsScrollingUp(!isScrollingDown);
      setPreviousScrollPosition(currentScrollPosition);
      setImageUrl(currentScrollPosition <= 0 ? logo : logoBlue);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [previousScrollPosition]);

  const handleClick = () => {
    setIsToggled(!isToggled);
  };

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-light bg-light ${
        isScrollingDown || (isScrollingUp && !previousScrollPosition <= 0)
          ? "header--scrolling-down"
          : ""
      }`}
    >
      <div className="container">
        <a className="navbar-brand" href="#">
          <img src={imageUrl} alt="" />
        </a>
        <button onClick={handleClick} className="navbar-toggler">
          <span onClick={handleClick} className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${
            isToggled ? "toggled animate_animated animate__fadeInDown" : ""
          }`}
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <a onClick={handleClick} className="nav-link" href="#home">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleClick} className="nav-link" href="#about">
                About
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleClick} className="nav-link" href="#tasks">
                Tasks
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleClick} className="nav-link" href="#work">
                Work
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleClick} className="nav-link" href="#skills">
                Skills
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleClick} className="nav-link" href="#contact">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
